const clientIdDev = "94462e1e-ea34-4211-a090-5c418b805ef8";
const clientIdProd = "94462e1e-ea34-4211-a090-5c418b805ef8";

// Obtener el origen base de la aplicación
const appOrigin = window.location.origin;
const path = window.location.href;

// URLs conocidas para cada ambiente
const DEV_URL = "https://green-moss-0ae320e0f.4.azurestaticapps.net/login";
const PROD_URL = "https://jolly-ocean-09ffc040f.4.azurestaticapps.net/login";
const LOCAL_URL = "http://localhost:3000/login";

const isDev = path === LOCAL_URL || path === DEV_URL;
const isProd = path === PROD_URL;

export const msalConfig = {
  auth: {
    clientId: isDev ? clientIdDev : clientIdProd,
    authority: "https://login.microsoftonline.com/5368fc5a-2692-4a6a-b226-e2802e94e22b",
    redirectUri: isDev || isProd ? path : undefined,
  },
  acceptMappedClaims: true,
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
  prompt: "select_account",
};
